export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13141.cc5ac09a.jpg";